import {
  toastTypes,
  errorMessages,
  BRAND_REPORT_INFO_TOAST_DURATION_MS,
} from "../../../constants";
import {
  customToast,
  UTCToDateFormat,
  convertFromDateToUnix,
  convertToDateToUnix,
} from "../../../../../shared";

export const validateDateRange = (createdAt, startDate, endDate) => {
  if (!createdAt) return true;
  const brandCreatedAtUnix = createdAt;
  const createDateFrom = convertFromDateToUnix(startDate);
  const createDateTo = convertToDateToUnix(endDate);
  if (
    createDateTo < brandCreatedAtUnix &&
    createDateFrom < brandCreatedAtUnix
  ) {
    customToast(
      errorMessages.NO_DATA_FOUND_IN_SELECTED_DATE_RANGE,
      toastTypes.ERROR
    );
    return false;
  } else if (
    createDateTo > brandCreatedAtUnix &&
    createDateFrom < brandCreatedAtUnix
  ) {
    customToast(
      `Data is only available from ${UTCToDateFormat(createdAt)}`,
      toastTypes.INFO,
      BRAND_REPORT_INFO_TOAST_DURATION_MS
    );
  }
  return true;
};
